// extracted by mini-css-extract-plugin
module.exports = {"typeField":"Prestation_typeField__2fv4Y","header":"Prestation_header__2w0DF"};